var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgSettingPhone2 = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.89526 1.29205L2.67158 0.842598C3.40041 0.421422 4.3153 0.648928 4.81193 1.37332L5.79851 2.81701C6.22806 3.4456 6.23369 4.29359 5.8106 4.9133L4.63409 6.63791C4.8951 7.46078 5.34343 8.22915 5.97751 8.94336C6.58286 9.63618 7.31993 10.1976 8.14506 10.5945L9.78122 9.61862C10.4021 9.24945 11.1801 9.35133 11.7117 9.87116L12.9525 11.0816C13.5715 11.6863 13.685 12.68 13.2177 13.4074L12.7167 14.1871C12.2181 14.9629 11.3671 15.3901 10.4832 15.3071C8.3959 15.1123 6.21856 13.6627 3.95043 10.9586C1.67902 8.2503 0.567854 5.77436 0.618332 3.53373C0.639362 2.59087 1.12465 1.73781 1.89526 1.29205Z",
    fill: "#A8B1C1"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSettingPhone2);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/settingPhone2.dedc3e462023eae6437d23faa3d1dd51.svg";